const AddContactsModalStyles = {
  containerTitle: {
    color: "#475569",
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: 1.5,
  },
  groupTypeItem: {
    display: "flex",
    flexDirection: "column",
  },
  autoCompleteBox: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  dropDown: {
    backgroundColor: "#FFFFFF",
    "& .MuiSelect-outlined": {
      color: "#475569",
      fontWeight: 600,
    },
    "&:hover": {
      background: "transparent",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  autoComplete: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    "& .MuiAutocomplete-inputRoot": {
      color: "#475569",
      fontWeight: 600,
    },
    "&:hover": {
      background: "transparent",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
  gridItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  gridItemBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: "1px solid #47556940",
  },
};

export default AddContactsModalStyles;
